import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { Sidecar } from '@swf/poker';

import { usePokerPowerPathWidget } from '../../../model';

const SidecarContainer: React.FC = () => {
  const { widgetSelect } = usePokerPowerPathWidget();
  const tournament = useSelector(widgetSelect.getSelectedTournament);
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);

  return (
    <Sidecar
      buttonsSize="small"
      tournament={tournament}
      showRegisterButton={!isEmbedded}
      showLobbyButton={isEmbedded}
    />
  );
};

export default SidecarContainer;
